<template>
  <div>退出成功</div>
</template>

<script>
// import mgr from "@/oidc";
import { mapActions } from "vuex";
export default {
  name: 'Logout',
  created() {
    // mgr.signoutRedirectCallback().then(() => {
    //   mgr.clearStaleState()
    //   window.localStorage.removeItem('userInfo')
    //   window.localStorage.removeItem('token')
    // })
    this.removeOidcUser();
    this.$router.push('/')
  },
  methods: {
    ...mapActions("oidc", [
      "removeOidcUser"
    ]),
  }
}
</script>

<style>

</style>
